var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobPicUploaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "PictureUploadedTitle"
  }, "Picture uploaded") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "PictureUploadedTitle"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4B7BFF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.948,
    height: 48.5,
    x: 0.75,
    y: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    transform: "translate(.862 18.966)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.371,
    x2: 17.415,
    y1: 17.294,
    y2: 0.368
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.415,
    x2: 41.871,
    y1: 0.368,
    y2: 29.804
  })), /*#__PURE__*/React.createElement("line", {
    x1: 33.985,
    x2: 42.739,
    y1: 37.566,
    y2: 28.813,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.224,
    cy: 15.086,
    r: 5.716
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "square",
    d: "M43.1034483,29.1857639 C43.1034483,29.1857639 46.3194002,32.5115275 52.7513041,39.1630547 C46.3194002,32.5115275 43.1034483,29.1857639 43.1034483,29.1857639 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobPicUploaded);
export default __webpack_public_path__ + "static/media/mob-pic-uploaded.dd6e27bba96df2e697eb611b2d6d601c.svg";
export { ForwardRef as ReactComponent };